/**
 * iurop-wishlist.js — pagina de favoritos.
 *
 * Lee los handles de localStorage 'laganini:wishlist' y trae cada tarjeta
 * SERVER-RENDERED via /products/<handle>?view=card (product.card.liquid).
 * - Respeta el prefijo de idioma (Shopify.routes.root) para precios/textos.
 * - Un 404 (producto borrado/despublicado) purga el handle del almacen.
 * - 'wishlist:changed' (lo emite iurop-product-card.js al tocar un corazon)
 *   retira la tarjeta sin recargar y actualiza contador/estado vacio.
 */
(function () {
  'use strict';

  var KEY = 'laganini:wishlist';
  var MAX = 48;

  function readHandles() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.slice(0, MAX) : [];
    } catch (_) {
      return [];
    }
  }

  function writeHandles(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (_) {
      /* storage lleno/bloqueado */
    }
  }

  function init(root) {
    if (root.__lgWishlistInit) return;
    root.__lgWishlistInit = true;

    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var loading = root.querySelector('[data-wishlist-loading]');
    var count = root.querySelector('[data-wishlist-page-count]');
    if (!grid || !empty) return;

    var rootUrl =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function refreshState() {
      var items = grid.children.length;
      grid.hidden = items === 0;
      empty.hidden = items > 0;
      if (count) {
        count.hidden = items === 0;
        count.textContent = items;
      }
    }

    function render() {
      var handles = readHandles();
      if (loading) loading.hidden = false;
      grid.innerHTML = '';

      if (!handles.length) {
        if (loading) loading.hidden = true;
        refreshState();
        return;
      }

      var dead = [];
      var fetches = handles.map(function (handle) {
        return fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '?view=card', {
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            if (res.status === 404) {
              dead.push(handle);
              return '';
            }
            return res.ok ? res.text() : '';
          })
          .catch(function () {
            return '';
          });
      });

      Promise.all(fetches).then(function (chunks) {
        grid.innerHTML = '';
        var failed = 0;
        chunks.forEach(function (html, i) {
          if (!html) {
            if (dead.indexOf(handles[i]) === -1) failed += 1;
            return;
          }
          var li = document.createElement('li');
          li.className = 'laganini-wishlist__item';
          li.setAttribute('data-wishlist-item', handles[i]);
          li.innerHTML = html;
          grid.appendChild(li);
        });
        if (dead.length) {
          writeHandles(
            readHandles().filter(function (h) {
              return dead.indexOf(h) === -1;
            })
          );
          // sincroniza el contador del header (la purga no pasa por el toggle)
          document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: {} }));
        }
        // Fallos TRANSITORIOS (red/429, no 404): reintento automatico una vez
        // en vez de mentir con "no tienes favoritos" (P2: capturar el status,
        // un 429 se lee como vacio).
        if (failed > 0 && !grid.children.length && !root.__lgWishlistRetried) {
          root.__lgWishlistRetried = true;
          window.setTimeout(render, 1800);
          return;
        }
        if (loading) loading.hidden = true;
        refreshState();
        // Re-engancha galeria/quick-add de las cards inyectadas
        document.dispatchEvent(new CustomEvent('iurop:product-list:rendered'));
      });
    }

    // Quitar el corazon en esta pagina = retirar la tarjeta al momento
    document.addEventListener('wishlist:changed', function (e) {
      var d = e.detail || {};
      if (d.active === false && d.handle) {
        var item = grid.querySelector('[data-wishlist-item="' + d.handle + '"]');
        if (item) item.remove();
        refreshState();
      }
    });

    // Cambios desde OTRA pestana
    window.addEventListener('storage', function (e) {
      if (!e.key || e.key === KEY) render();
    });

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wishlist-page]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
